import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IBasePromotionRequest, IPromotions, PromotionService } from 'src/app/store/services/promotion.service';
import { SettingService } from '../../services/setting.service';
import { MenuService } from 'src/app/store/services/menu.service';
import { LoaderService } from '../../services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { AddressEditorModalComponent } from '../address-editor-modal/address-editor-modal.component';
import { IGeopoint } from 'src/app/store/pages/list-page/list-page.component';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { AlertController, ModalController } from '@ionic/angular';
import { GoogleApiService } from '../../services/google-api.service';
import { StoreService } from 'src/app/store/services/store.service';
import { Storage } from '@ionic/storage';
import { TranslationService } from '../../services/translation.service';
const CACHE_KEY = 'cartStorage';

@Component({
    selector: 'app-view-promo-offer',
    templateUrl: './view-promo-offer.component.html',
    styleUrls: ['./view-promo-offer.component.scss'],
    standalone: false
})
export class ViewPromoOfferComponent implements OnInit {
  @Input() promotionId: string;
  @Input() isMobile: boolean;
  mobileCart: boolean = (window.innerWidth < 1100);
  

  @ViewChild('fullPromo') fullPromo: ElementRef;
  @ViewChild('promoFront') promoFront: ElementRef;
  @ViewChild('promoBack') promoBack: ElementRef; 

  // not selected but using the promotion as base.
  selectOrderType: string;

  promotions: IPromotions[] = [];
  //promotion: IPromotions;
  promotion: any;
  promotionRequest: IBasePromotionRequest;

  lang: string='fr';
  couponNum: string;

  private _geopoint: IGeopoint;
  get geopoint(): IGeopoint {
    return this._geopoint;
  }

  set geopoint(value: IGeopoint) {
    this._geopoint = value;
    if (!value) {
      return;
    }
      
    this.menuService.store._distance = GeolocationHelpers.distance(value.latitude, value.longitude, this.menuService.store.address.latitude, this.menuService.store.address.longitude);
  }

  constructor(
    public promoService: PromotionService,
    private settingService: SettingService,
    public menuService: MenuService,
    //public translateService: TranslateService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private alertCtrl: AlertController,
    private storage: Storage,
    private modalCtrl: ModalController,
    private googleApiService: GoogleApiService,
    private storeService: StoreService,
    public translationService: TranslationService
  ) { }

  ngOnInit() {
    this.getAllPromotions()

    this.lang = this.translationService.getLanguage();
    
    if(localStorage['StoreId'])
    {
      this.menuService.getStore(localStorage['StoreId'], null)
    }

    if (window.matchMedia("(max-width: 1100px)").matches) {
        this.mobileCart = true;
      } else {
        this.mobileCart = false;
      }
  }

  // this is used to check how long is it still valid for
  /*
  ngAfterViewInit() {
      this.startCountDown();
  }
  */

  async closeModel() {
    await this.modalCtrl.dismiss();
  }

  applypromo() {
    localStorage['Coupon'] = this.promotion.promotionalCode;

    /*
    setTimeout(() => {
      this.menuService.orderCheckoutPromo();
    }, 500);
    */



    if(localStorage['cartStorage'] && localStorage['StoreId']) {
      let items = (JSON.parse(localStorage['cartStorage']));

      if(items.length == 0) {
        this.noCart();
        return;
      }

      if(localStorage[CACHE_KEY]) {
        this.menuService.order.orderItems = JSON.parse(localStorage[CACHE_KEY])
      }
      console.log(this.menuService.order);

      
      //let orderType = localStorage.getItem('orderType');
      let orderType = localStorage.getItem('orderType');

      if(orderType != null) {
        orderType = this.promotion.services[0];
      }

      if (orderType != null) {
        this.menuService.order._deliveryType = orderType == 'pickup' ? "pickup" : "delivery";
        let availability = true;
        
        items.map(item => { 
          if(!item.isDelivery && this.menuService.order._deliveryType === 'delivery') { 
            availability = false;
          }
        });

        if(!availability) {
          this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.ItemNotAvailableDelivery'))
          return
        } 
        
        this.couponCheckout();
      } else {
        //this.selectOrderType.open();
      }        
    } else {
      this.noCart();
      return;
    }
      
  }

  couponCheckout() {
    if(this.promotion.promotionalCode)
    {
      localStorage['Coupon'] = this.promotion.promotionalCode;
    }
    
    setTimeout(async () => {
      //this.menuService.orderCheckoutPromo();
      await this.modalCtrl.dismiss();

      if(this.mobileCart) {
        this.menuService.cart();
      } else {
        this.menuService.desktopCart(1);
      }
    }, 500);
  }

  noCart() {
    this.alertCtrl.create({
      header: this.translationService.translate('Coupon.NoCart'),
      message: this.translationService.translate('Coupon.NoCartDescription'),
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });
  }

  notAvailable(header,message) {

    this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });

  }

  chooseOrderType(e) {
    this.menuService.order._deliveryType = e.detail.value;

    if(e.detail.value)
    {
      if(this.menuService.order._deliveryType==='delivery') {
        this.beginChangeAddress();
      } else {
        //this.checkout();
        this.applypromo();
        
      }
      
      if(e.detail.value == 'delivery') {
        this.storage.get('deliveryAddress').then(address=>{

          if(address) {
            this.couponCheckout();
          } else {
            this.beginChangeAddress();  
          }
              
        })

      } else if(e.detail.value == 'pickup') {
        this.couponCheckout();
      }

      this.selectOrderType = '';
    }
  }

  /*
  checkout() {
    if(localStorage['cartStorage'] && localStorage['StoreId']) {

      let items = (JSON.parse(localStorage['cartStorage']));
      if(items.length == 0) {
        this.noCart();
        return;
      }
      let orderType = localStorage.getItem('orderType');

      if (orderType != null) {
        this.menuService.order._deliveryType = orderType == 'pickup' ? "pickup" : "delivery";
        let availability=true;
        items.map(item => {
          
          if(!item.isDelivery && this.menuService.order._deliveryType==='delivery') { 
            availability=false;
          }

        });

          if(!availability) {
            this.notAvailable(this.translateService.instant('Coupon.ItemNotAvailable'), this.translateService.instant('Coupon.ItemNotAvailableDelivery'))
            return
          } 
        
          this.couponCheckout();
      } else {
        //this.selectOrderType.open();
      }        
    } else {
      this.noCart();
      return;
    }
  }
  */

  async beginChangeAddress() {
    
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        skipProvinceValidation: true
      }
    });

    modal
      .onDidDismiss()
      .then(async (result) => {

        if (!result.data)
          return;

        if(result.data) {
          this.storage.set('deliveryAddress',result.data);
          this.googleApiService.getAddressGeometry(result.data).subscribe((result) => {

            this.geopoint = {
              latitude: result.lat,
              longitude: result.lng
            }

            this.menuService.store = this.storeService.setDeliveryPrice(this.menuService.store, result.data,this.geopoint);

            if(this.menuService.store._distance>this.menuService.store.deliveryRadius) 
            {
              this.storeTooFar(); 
              return;
            }
            else {
              this.couponCheckout()          
            }
          });
      
        }
      });

      await modal.present();
  }

  storeTooFar() {
    this.alertCtrl.create({
      header: this.translationService.translate('Coupon.CannotDeliver'),
      message: this.translationService.translate('Coupon.ChangeAddress'),
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then( al => {
      al.present();
    });
    
    this.selectOrderType = '';
    return;
  }

  
  
  


  // getting promotions details
  getAllPromotions(){
    this.fetchPromotions().subscribe(async promotions => {
      this.promotions = [];

      this.promotions = promotions;
      
      /*
      for(var i = 0; i < promotions.length; i++){
        // inject the image URL in each promotions
        this.promotions[i].visualConfig['imgURL'] = await this.promoService.fetchImage(promotions[i].visualConfig.imgShortName);
      }
      */

      var promotion: IPromotions;
      for(var i = 0; i < promotions.length; i++) {
        if(this.promotionId == promotions[i].id) {
          this.promotion = promotions[i];
          promotions[i].services[0];
        }
      }

      this.promotion.visualConfig['imgURL'] = await this.promoService.fetchImage(this.promotion.visualConfig.imgShortName);
      this.selectOrderType = this.promotion.services[0];

      console.log(this.promotion);
    });
  }

  fetchPromotions() {
    this.promotionRequest = {
      merchantId: this.settingService.getMerchantId(),
    }

    return this.promoService.getPromotions(this.promotionRequest);
  }

  getpromoImage(promotion){
    if(promotion.visualConfig){
      if(promotion.visualConfig.imgURL) {
        const url = promotion.visualConfig.imgURL;
        return url;
      }     
    }
  }


  flip() {
    // flip triggered

    let fullPromo = this.fullPromo.nativeElement;
    let front = this.promoFront.nativeElement;
    let back = this.promoBack.nativeElement;
    back.classList.remove('hide');
    back.style.height=front.offsetHeight+'px';
    fullPromo.removeAttribute("id");  
    fullPromo.setAttribute("id","b");

    /*
    const popup = document.querySelector('.viewpromo-popup-model') as HTMLElement | null;
    if (!popup) return;

    popup.classList.remove('flip-animate');

    // Force reflow so the animation can retrigger
    void popup.offsetWidth;

    popup.classList.add('flip-animate');
    */
    const modalWrapper = document.querySelector(
      '.viewpromo-popup-model .modal-wrapper'
    ) as HTMLElement | null;

    if (!modalWrapper) return;

    modalWrapper.classList.remove('flip-animate');
    void modalWrapper.offsetWidth; // force reflow
    modalWrapper.classList.add('flip-animate');
  }

  turnBack() { 
    // turn back triggered

    let back = this.promoBack.nativeElement; 
    let fullPromo = this.fullPromo.nativeElement;
    back.classList.add('hide');
    fullPromo.removeAttribute("id");
    fullPromo.setAttribute("id","c");

    /*
    const popup = document.querySelector('.viewpromo-popup-model') as HTMLElement | null;
    if (!popup) return;

    popup.classList.remove('flip-animate');

    // Force reflow so the animation can retrigger
    void popup.offsetWidth;

    popup.classList.add('flip-animate');
    */
    const modalWrapper = document.querySelector(
      '.viewpromo-popup-model .modal-wrapper'
    ) as HTMLElement | null;

    if (!modalWrapper) return;

    modalWrapper.classList.remove('flip-animate');
    void modalWrapper.offsetWidth; // force reflow
    modalWrapper.classList.add('flip-animate');
  }

}
